'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

class BitmapFontData {
  constructor() {
    this.info = [];
    this.common = [];
    this.page = [];
    this.char = [];
    this.kerning = [];
    this.distanceField = [];
  }
}

exports.BitmapFontData = BitmapFontData;
//# sourceMappingURL=BitmapFontData.js.map
